import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import StoreGrid from "../components/storegrid"
import { FilterProducts } from "../helpers/product-filter"

const BabyAccessories = () => (
	<Layout>
		<SEO title="Baby Accessories" />

		<div className="homepageBlurb">
			<h1>Baby Accessories</h1>
			<p>From the newborn essentials that every new parent needs, nursey gifts to accessorise babys new room or cute items for the new parents, we have everything you need.</p>
			<p>Our essential booties, bibs & muslin squares make great additions to any hamper. Our photo frames, milestone cards & mats and other nursery accessories make great gifts too! Perfect pregnancy presents, baby shower gifts, newborn baby gifts and gifts to congratulate new parents.</p>
		</div>
		
		<StoreGrid products={FilterProducts("baby-accessories")} />
	</Layout>
)

export default BabyAccessories
